import type { GenericOptions } from "contract-generator";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export type Action =
  | "copy"
  | "remix"
  | "download-npm"
  | "download-vendored"
  | "download-hardhat";
export type Language = "solidity" | "cairo";

export async function postConfig(
  opts: Required<GenericOptions>,
  action: Action,
  language: Language
) {
  window.gtag?.("event", "wizard_action", {
    ...opts,
    action,
    wizard_lang: language,
  });
}
